export const ERP_DATA_TABLE_VIEW_ROW_EVENT = 'erp-data-table:view-row';

export interface ErpDataTableViewRowParams {
  id: string;
  row: Record<string, unknown>;
}

export const dispatchErpDataTableViewRow = (params: ErpDataTableViewRowParams) => {
  if (typeof window === 'undefined') return false;

  const event = new CustomEvent<ErpDataTableViewRowParams>(ERP_DATA_TABLE_VIEW_ROW_EVENT, {
    detail: params,
    cancelable: true
  });

  return !window.dispatchEvent(event);
};

export const subscribeErpDataTableViewRow = (handler: (params: ErpDataTableViewRowParams) => void | Promise<void>) => {
  const listener = (event: Event) => {
    const viewEvent = event as CustomEvent<ErpDataTableViewRowParams>;
    if (!viewEvent.detail?.row) return;

    viewEvent.preventDefault();
    viewEvent.stopImmediatePropagation();
    void handler(viewEvent.detail);
  };

  window.addEventListener(ERP_DATA_TABLE_VIEW_ROW_EVENT, listener);
  return () => window.removeEventListener(ERP_DATA_TABLE_VIEW_ROW_EVENT, listener);
};
